import { PropsWithChildren } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { RiDragMove2Line } from 'react-icons/ri';

interface SortableItemProps {
  id: string;
  actionsNode?: JSX.Element | null;
  isHidden?: boolean;
}

export function SortableItem({
  id,
  children,
  actionsNode,
  isHidden = false,
}: PropsWithChildren<SortableItemProps>) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className={`w-full`}>
      <div
        className={`relative w-full h-[100px] rounded-md bg-white shadow-md ${
          id.includes('extra-space') && 'hidden'
        } ${isHidden && 'opacity-0 h-full'}`}
      >
        <div
          className={`absolute top-1/2 -translate-y-1/2 left-4 p-[2px] rounded text-[24px] text-warmGray-300 cursor-pointer hover:bg-gray-300 hover:text-white active:bg-gray-300 active:text-white transition-transform`}
          {...attributes}
          {...listeners}
        >
          <RiDragMove2Line />
        </div>
        <div className="w-full h-full">{children}</div>
        <div className="absolute top-1/2 -translate-y-1/2 right-4">
          {actionsNode}
        </div>
      </div>
    </div>
  );
}
